export type FormHeaderProps = {
  title: string
}

export function FormHeader({ title }: FormHeaderProps) {
  return (
    <div className="mb-4 flex items-center lg:mb-8">
      <div className="bg-primary mr-3 h-6 w-1"></div>
      <h2 className="text-xl font-semibold">{title}</h2>
    </div>
  )
}
